export default __webpack_public_path__ + "static/media/introduction_vn_mobile.606d14bb.png";